import Crud from '../components/Download/Crud'
import Add from '../components/Download/Add'
import Edit from '../components/Download/Edit'

let routes = {
    path: '/download',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/download',
            component: Crud
        },
        {
            path: '/download/add',
            component: Add
        },
        {
            path: '/download/edit/:id',
            component: Edit
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/download.js